import React from 'react';
import { usePayApi, ModeBadge } from './shared';
import { PaymentsOverview } from './PaymentsOverview';
import { PaymentsProviders } from './PaymentsProviders';
import { PaymentsTransactions } from './PaymentsTransactions';
import { PaymentsLinks, PaymentsWebhooks, PaymentsSettings, PaymentsAudit } from './PaymentsPanels';

export const PAYMENTS_TABS = ['payments-overview', 'payments-providers', 'payments-transactions', 'payments-links', 'payments-webhooks', 'payments-settings', 'payments-audit'];
const TITLES = { 'payments-overview': 'Overview', 'payments-providers': 'Providers', 'payments-transactions': 'Transactions', 'payments-links': 'Payment Links',
  'payments-webhooks': 'Webhooks', 'payments-settings': 'Settings', 'payments-audit': 'Audit History' };

// Admin → Payments / Merchant Processing (mode banner on every screen)
export const PaymentsCenter = ({ tab, token }) => {
  const { data } = usePayApi(token, '/overview');
  const p = data?.providers?.[0];
  const canEdit = !!data?.can_edit;
  return (
    <div className="space-y-5" data-testid={`payments-center-${tab}`}>
      <div className={`flex flex-wrap items-center justify-between gap-3 rounded-lg px-4 py-3 border ${p?.mode === 'live' ? 'bg-emerald-50 border-emerald-200' : 'bg-amber-50 border-amber-300'}`} data-testid="payments-mode-banner">
        <div><h2 className="text-lg font-semibold">Payments · {TITLES[tab]}</h2>
          <p className="text-xs text-neutral-600">{p ? (!p.configured ? 'Payments Setup Required: no card payments until Stripe is set up and verified' : `${p.label}: ${p.mode === 'live' ? (p.live_confirmed ? 'real customer payments' : 'live keys present, waiting for Admin confirmation') : 'test mode, no real money moves'}`) : 'Loading…'}</p></div>
        {p && <ModeBadge mode={p.configured ? p.mode : null} size="lg" testId="payments-banner-mode" />}
      </div>
      {tab === 'payments-overview' && <PaymentsOverview token={token} />}
      {tab === 'payments-providers' && <PaymentsProviders token={token} />}
      {tab === 'payments-transactions' && <PaymentsTransactions token={token} canEdit={canEdit} />}
      {tab === 'payments-links' && <PaymentsLinks token={token} />}
      {tab === 'payments-webhooks' && <PaymentsWebhooks token={token} />}
      {tab === 'payments-settings' && <PaymentsSettings token={token} />}
      {tab === 'payments-audit' && <PaymentsAudit token={token} />}
    </div>
  );
};
